var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{attrs:{"id":("myChart" + (_vm.type ? '-'+_vm.type : '') + (_vm.section ? '-'+_vm.section : '')),"width":_vm.size * 2,"height":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }